export enum CREDIT_LAYER_ENUM {
    JETVAM = 1,
    AIR_CONDITIONER = 4,
  }